// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake"}[chunkId] || chunkId) + "." + {"102":"942a32e7","133":"106a2b07","511":"449bcd15"}[chunkId] + ".chunk.js";
};